import type { ReactNode } from "react";

interface EmptyStateProps {
  title?: string;
  note?: string;
  icon?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}

/**
 * Honest "there is nothing here" block. Missing data is a normal state in this
 * app (a collector has not run yet, Monobank is rate-limited, a month is empty),
 * so it gets a real design instead of a blank rectangle.
 */
export default function EmptyState({
  title = "Немає даних",
  note,
  icon = "◌",
  action,
  compact = false,
  className = "",
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 text-center ${
        compact ? "py-6" : "py-10"
      } ${className}`}
      role="status"
    >
      <span className="grid size-9 place-items-center rounded-full bg-surface-2 text-sm text-muted">
        {icon}
      </span>
      <div className="text-sm font-medium text-fg">{title}</div>
      {note && <div className="max-w-sm text-xs leading-relaxed text-muted">{note}</div>}
      {action}
    </div>
  );
}
